import { OptionSubCategory } from 'owa-options-core';
import { PremiumStorageOptionApril } from 'owa-premium-storage-option';
import { SubscriptionOptionApril } from 'owa-subscription-option';
import { DomainEnrollOption } from 'owa-domain-option';
import { getAccountInformation } from 'owa-storage-option';
import { fetchAndValidateDomain } from 'owa-domain-option';
import { getSubscriberType } from 'owa-domain-option';
import { getPremiumUser } from 'owa-domain-option';
import { PremiumSupportOption } from 'owa-premium-support-option';
import { trace } from 'owa-trace';
import { getPremiumSupportFlightStatus } from 'owa-premium-support-option';
import { CloudCacheOption } from 'owa-cloud-cache-accounts-option/lib/CloudCacheOption';

let premiumDashboardFeaturesSubCategory: OptionSubCategory = {
    key: 'features',
    titleStringKey: 'options_premiumSubOption_Features',
    options: [
        PremiumStorageOptionApril,
        SubscriptionOptionApril,
        PremiumSupportOption,
        CloudCacheOption,
        DomainEnrollOption,
    ],
    onSelected: () => {
        return loadPremiumFeatureDashBoard();
    },
};

async function loadPremiumFeatureDashBoard(): Promise<boolean> {
    try {
        await getAccountInformation();
        await fetchAndValidateDomain();
        await getPremiumUser();
        await getSubscriberType();
        await getPremiumSupportFlightStatus();
        return true;
    } catch (e) {
        trace.warn(e.message);
        return false;
    }
}

export default premiumDashboardFeaturesSubCategory;
